import React from 'react';

import {
  IconButton,
  Card,
  CardHeader,
  CardContent,
  CloseIcon,
} from '@gogame/components';
import { FormField } from '@gogame/form';

import { COMPENSATIONS, DEPENDENCIES } from 'scenes/PromoCodes/constants';

import Compensations from './Compensations';

export const Reward = ({
  name,
  label,
  maxValue,
  isCompensationSupported,
  onRemove,
}) => {
  return (
    <Card elevation={6}>
      <CardHeader
        action={
          <IconButton
            icon={<CloseIcon />}
            tooltip={'Remove'}
            onClick={onRemove}
          />
        }
      >
        <FormField.TextField
          name={`${name}.value`}
          type={'number'}
          placeholder={'0'}
          padding={'0'}
          label={label}
          required={true}
          InputLabelProps={{
            shrink: true,
          }}
          {...(maxValue && {
            helper: `${maxValue} maximum`,
          })}
        />
      </CardHeader>
      {isCompensationSupported ? (
        <CardContent>
          <Compensations
            name={`${name}.${COMPENSATIONS}`}
            depends={DEPENDENCIES[COMPENSATIONS]}
          />
        </CardContent>
      ) : null}
    </Card>
  );
};
